import { useEffect, useRef } from 'react';
import { useComponentSize } from '@carnica/utils/hooks';
import { useListener } from "../../../../lib";
import { getSizingData } from "./getSizingData";
import { calculateNodeHeight, createHiddenNode } from "./helper";
var triggerFocus = function triggerFocus(element) {
  var eventType = 'onfocusin' in element ? 'focusin' : 'focus';
  var bubbles = 'onfocusin' in element;
  var event;
  if ('createEvent' in document) {
    event = document.createEvent('Event');
    event.initEvent(eventType, bubbles, true);
  } else if ('Event' in window) {
    event = new Event(eventType, {
      bubbles: bubbles,
      cancelable: true
    });
  }
  element.focus();
  if (event) {
    element.dispatchEvent(event);
  }
};
export var useTextArea = function useTextArea(params) {
  var minRows = params.minRows,
    maxRows = params.maxRows,
    onChangeProp = params.onChange,
    value = params.value,
    autoFocus = params.autoFocus;
  var heightRef = useRef(0);
  var textAreaRef = useRef(null);
  var _useComponentSize = useComponentSize(textAreaRef),
    width = _useComponentSize.width;
  var hiddenNodeRef = useRef(null);
  var resize = function resize() {
    var _textAreaRef$current, _textAreaRef$current2;
    var nodeSizingData = getSizingData(textAreaRef.current);
    if (!nodeSizingData) {
      return;
    }
    var hiddenNode = createHiddenNode(textAreaRef, hiddenNodeRef.current);
    if (!hiddenNodeRef.current) {
      hiddenNodeRef.current = hiddenNode;
    }
    var _calculateNodeHeight = calculateNodeHeight(hiddenNode, nodeSizingData, ((_textAreaRef$current = textAreaRef.current) === null || _textAreaRef$current === void 0 ? void 0 : _textAreaRef$current.value) || ((_textAreaRef$current2 = textAreaRef.current) === null || _textAreaRef$current2 === void 0 ? void 0 : _textAreaRef$current2.placeholder) || 'x', minRows, maxRows),
      height = _calculateNodeHeight.height,
      isOverflow = _calculateNodeHeight.isOverflow;

    // Необходимо, так как из-за бордеров при равной высоте появляется скрол
    if (isOverflow) {
      var _textAreaRef$current3;
      (_textAreaRef$current3 = textAreaRef.current) === null || _textAreaRef$current3 === void 0 || _textAreaRef$current3.style.removeProperty('overflow');
    } else {
      var _textAreaRef$current4;
      (_textAreaRef$current4 = textAreaRef.current) === null || _textAreaRef$current4 === void 0 || _textAreaRef$current4.style.setProperty('overflow', 'hidden', 'important');
    }
    if (heightRef.current !== height) {
      var _textAreaRef$current5;
      heightRef.current = height;
      (_textAreaRef$current5 = textAreaRef.current) === null || _textAreaRef$current5 === void 0 || _textAreaRef$current5.style.setProperty('height', "".concat(height, "px"), 'important');
    }
  };
  var onChange = function onChange(e) {
    if (value === undefined) {
      resize();
    }
    onChangeProp === null || onChangeProp === void 0 || onChangeProp(e.target.value, e);
  };
  useEffect(resize, [textAreaRef, maxRows, minRows, value, width]);
  useListener('resize', resize);
  useListener('loadingdone', resize, {
    target: document.fonts
  });
  useEffect(function () {
    if (autoFocus) {
      setTimeout(function () {
        if (textAreaRef.current) {
          triggerFocus(textAreaRef.current);
        }
      }, 200);
    }
  }, [autoFocus]);
  return {
    textAreaRef: textAreaRef,
    onChange: onChange
  };
};